var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-template',{attrs:{"feature":"village","prestigeGain":_vm.prestigeGain}})
}
var staticRenderFns = []

export { render, staticRenderFns }